package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.itinerary.domain.model.ItineraryServiceFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryServiceOrderType
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.dropdown.EsFilterDropDownItem
import com.essntl.uikit.components.dropdown.EsFilterDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals

@Composable
fun ItineraryServiceFilterSection(
    filterOptions: ItineraryServiceFilterOptions,
    onFilterOptionsChange: (ItineraryServiceFilterOptions) -> Unit,
) {
    var isSortFilterExpanded by remember { mutableStateOf(false) }
    val itineraryOrderTypes =
        listOf(
            ItineraryServiceOrderType.StartTime,
            ItineraryServiceOrderType.Client,
            ItineraryServiceOrderType.Status,
        )

    Box {
        EsMediumOutlineButton(
            text = filterOptions.selectedItineraryServiceOrderType.orderName,
            onClick = {
                isSortFilterExpanded = !isSortFilterExpanded
            },
            suffixIconRes = EsIcons.Sort,
        )

        EsFilterDropDownMenu(
            expanded = isSortFilterExpanded,
            onDismissRequest = { isSortFilterExpanded = false },
            list = itineraryOrderTypes,
            selectedItemIds = setOf(filterOptions.selectedItineraryServiceOrderType),
            clearing = false,
            content = {
                itineraryOrderTypes.forEach { order ->
                    val isSelected = rememberEquals(
                        order,
                        setOf(filterOptions.selectedItineraryServiceOrderType),
                    ) { it }

                    key(order) {
                        EsFilterDropDownItem(
                            onClick = {
                                onFilterOptionsChange(
                                    filterOptions.copy(
                                        selectedItineraryServiceOrderType =
                                        if (order == filterOptions.selectedItineraryServiceOrderType)
                                            ItineraryServiceOrderType.Default
                                        else
                                            order,
                                    ),
                                )
                            },
                            title = order.orderName,
                            selected = isSelected,
                            modifier = Modifier
                                .padding(
                                    vertical = .5f.spacing,
                                    horizontal = 1.5f.spacing,
                                ),
                        )
                    }
                }
            },
            modifier = Modifier
                .width(308.dp),
        )
    }
}